import { Rise, Words } from "../components/Reveal";
import { COPY } from "../content/copy";
import { useTexts } from "../lib/settings";

export default function Apertura() {
    const a = COPY.apertura;
    const t = useTexts();
    return (
        <section id="apertura" className="section apertura" data-testid="apertura-block">
            <div className="container">
                <h2 className="display apertura-headline" data-testid="apertura-headline">
                    <Words text={t.headline_a} /> <Words text={t.headline_b} italic />
                </h2>
                <Rise>
                    <p className="lead apertura-sub">{t.apertura_sub}</p>
                </Rise>
                <Rise delay={0.08}>
                    <p className="caption apertura-proof" data-testid="apertura-proof">{a.proof}</p>
                </Rise>
                <Rise delay={0.1}>
                    <p className="caption apertura-caption">{a.caption}</p>
                </Rise>
            </div>
        </section>
    );
}
